import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { Col, Row, Button } from "react-bootstrap";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));

export default function EmployerSearchForm(props) {
    const [labelWidth, setLabelWidth] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);

    return (
        <div className={classes.container}>
            <Row>
                <Col md="10">
                            <FormControl fullWidth className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="OrganisationLegalName">
                                    Legal Name
								</InputLabel>
                                <OutlinedInput
                                    id="OrganisationLegalName"
                                    onChange={(ev) => props.model.OrganisationLegalName = ev.target.value}
                                    labelWidth={labelWidth}
                                    onKeyPress={props.onKeyUp}
                                />
                            </FormControl>
                </Col>
                <Col md="10">
                    <FormControl fullWidth className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="OrganisationTradeName">
                                    Trade Name
								</InputLabel>
                                <OutlinedInput
                                    id="OrganisationTradeName"
                                    onChange={(ev) => props.model.OrganisationTradeName = ev.target.value}
                                    labelWidth={labelWidth}
                                    onKeyPress={props.onKeyUp}
                                />
                            </FormControl>
                </Col>
                <Col md="10">
                    <FormControl fullWidth className={classes.formControl} variant="outlined">
                                <InputLabel ref={labelRef} htmlFor="OrganisationSdlNumber">
                                    SDL Number
								</InputLabel>
                                <OutlinedInput
                                    id="OrganisationSdlNumber"
                                    onChange={(ev) => props.model.OrganisationSdlNumber = ev.target.value}
                                    labelWidth={labelWidth}
                                    onKeyPress={props.onKeyUp}
                                />
                    </FormControl>
                </Col>
                </Row>
                             
        </div>
    );
}
